import { Avatar, Badge, Box, Card, Chip, CircularProgress, Grid, IconButton, LinearProgress, Typography, circularProgressClasses, Tooltip as MaterialToolTip, useTheme } from '@mui/material'
import DashboardService from '../../services/dashboard.service';
import moment from 'moment'
import { useEffect, useRef, useState } from 'react';
import 'chart.js/auto';
import * as XLSX from 'xlsx';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'react-chartjs-2';
import { ArcElement, Tooltip, Legend, Chart as ChartJS } from 'chart.js';
import { BasicTable, MapBase, MarkerClienteDash, TableBase } from '../../components';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BuildIcon from '@mui/icons-material/Build';
import FechaFunction from '../../function/FechaFunction';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterListIcon from '@mui/icons-material/FilterList';
import { showModal } from 'react-redux-modal-provider';
import ModalFilterDashPreServicios from '../../modals/dashboard/ModalFilterDashPreServicios';
ChartJS.register(ChartDataLabels, ArcElement, Tooltip, Legend);

const TabPreServiciosScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const chartRef = useRef(null);
    const [itemsOriginal, setItemsOriginal] = useState([]);
    const [items, setItems] = useState([]);
    const [fechaSelect, setFechaSelect] = useState({
        startDate: FechaFunction.format(new Date(), 'yyyy-MM-dd'),
        endDate: FechaFunction.format(new Date(), 'yyyy-MM-dd')
    });
    const [filtroTotal, setFiltroTotal] = useState({
        estado: [],
        fase: [],
        tecnologia: [],
        autorId: [],
    });
    const [countFilter, setCountFilter] = useState(0);
    const [itemsNumber, setItemsNumber] = useState({
        total: 0,
        activos: 0,
        instalados: 0,
        cancelados: 0
    });
    const [itemsEstado, setItemsEstado] = useState([]);
    const [itemsSubEstado, setItemsSubEstado] = useState([]);
    const [itemsFase, setItemsFase] = useState([]);
    const [itemsTecnologia, setItemsTecnologia] = useState([]);
    const [itemsPlan, setItemsPlan] = useState([]);
    const [itemsCreadoUsuario, setItemsCreadoUsuario] = useState([]);
    const [itemsFechasCreados, setItemsFechasCreados] = useState([]);
    const [itemsCategoria, setItemsCategoria] = useState([]);

    const agruparSegunElemento = (dataAll, elemt, setData) => {
        const agrupadoPorGrupo = dataAll.reduce((resultado, elemento) => {
            if (elemento[elemt]) {
                const grupo = elemento[elemt];
                if (!resultado[grupo]) resultado[grupo] = [];
                resultado[grupo].push(elemento);
            }
            return resultado;
        }, {});
        const newArray = Object.keys(agrupadoPorGrupo).map((grupo) => ({
            label: grupo,
            value: agrupadoPorGrupo[grupo].length,
        }));
        newArray?.sort((a, b) => b?.value - a?.value);
        setData(newArray);
    };

    const agruparConPorcentaje = (dataAll, elemt, setData) => {
        const agrupadoPorGrupo = dataAll.reduce((resultado, elemento) => {
            if (elemento[elemt]) {
                const grupo = elemento[elemt];
                if (!resultado[grupo]) resultado[grupo] = [];
                resultado[grupo].push(elemento);
            }
            return resultado;
        }, {});
        const newArray = Object.keys(agrupadoPorGrupo).map((grupo) => ({
            label: grupo,
            value: agrupadoPorGrupo[grupo].length,
        }));
        newArray?.sort((a, b) => b?.value - a?.value);
        const total = newArray.reduce((sum, item) => sum + item.value, 0);
        const dataWithPercentage = newArray.map(item => ({
            label: item.label,
            value: item.value,
            percentage: Number(((item.value / total) * 100).toFixed(2)),
        }));
        setData(dataWithPercentage);
    };

    const agruparConPorcentajeFoto = (dataAll, setData) => {
        const agrupadoPorGrupo = dataAll.reduce((resultado, elemento) => {
            const autorNombre = elemento?.autor?.nombre_p;
            if (autorNombre) {
                if (!resultado[autorNombre]) resultado[autorNombre] = [];
                resultado[autorNombre].push(elemento);
            }
            return resultado;
        }, {});
        const newArray = Object.keys(agrupadoPorGrupo).map((grupo) => ({
            label: grupo,
            value: agrupadoPorGrupo[grupo].length,
        }));
        newArray?.sort((a, b) => b?.value - a?.value);
        const total = newArray.reduce((sum, item) => sum + item.value, 0);
        const dataWithPercentage = newArray.map(item => ({
            label: item.label,
            value: item.value,
            percentage: Number(((item.value / total) * 100).toFixed(2)),
            img: dataAll?.find((e) => e?.autor?.foto_p && e?.autor?.nombre_p === item.label)?.autor?.foto_p
        }));
        setData(dataWithPercentage);
    };

    const obtenerFechasEnRango = (fechaInicio, fechaFin, dataAll) => {
        const fechas = [];
        let fechaActual = moment(fechaInicio);
        while (fechaActual.isSameOrBefore(fechaFin)) {
            const fechaFormateada = fechaActual.format('DD-MM-YYYY')?.toString();
            fechas.push({
                label: fechaFormateada,
                value: dataAll?.filter((e) => e?.fechaCreacion === fechaFormateada)?.length || 0
            });
            fechaActual.add(1, 'days');
        }
        setItemsFechasCreados(fechas);
    };

    const primeraCarga = (dataAll) => {
        const estadosActivos = ['FECHA PENDIENTE DE ASIGNAR', 'FECHA ASIGNADA', 'EN ESPERA DE DA', 'A REPROGRAMAR'];
        const estadosInstalados = ['INSTALADO'];
        const estadosCancelados = ['CANCELADO', 'SIN COBERTURA', 'NO LE INTERESA'];

        const activos = dataAll?.filter((e) => estadosActivos.includes(e?.estadoServicio_t))?.length || 0;
        const instalados = dataAll?.filter((e) => estadosInstalados.includes(e?.estadoServicio_t))?.length || 0;
        const cancelados = dataAll?.filter((e) => estadosCancelados.includes(e?.estadoServicio_t))?.length || 0;

        setItemsNumber({
            total: dataAll?.length,
            activos,
            instalados,
            cancelados
        });

        agruparConPorcentaje(dataAll, 'estadoServicio_t', setItemsEstado);
        agruparSegunElemento(dataAll, 'subEstadoServicio_t', setItemsSubEstado);
        agruparSegunElemento(dataAll, 'faseNombre', setItemsFase);
        agruparSegunElemento(dataAll, 'tipoTecnologia_t', setItemsTecnologia);
        agruparSegunElemento(dataAll, 'nombrePlan', setItemsPlan);
        agruparSegunElemento(dataAll, 'categoria_t', setItemsCategoria);
        agruparConPorcentajeFoto(dataAll, setItemsCreadoUsuario);
        obtenerFechasEnRango(
            moment(fechaSelect.startDate).add(3, 'hours').toDate(),
            moment(fechaSelect.endDate).add(3, 'hours').toDate(),
            dataAll
        );
    };

    const actualizar = async () => {
        await DashboardService.gralPreServicio({
            fecIni: fechaSelect.startDate,
            fecFin: fechaSelect.endDate
        }).then((resp) => {
            const data = resp?.data || resp;
            setItemsOriginal(data);
            setItems(data);
            primeraCarga(data);
        });
    };

    useEffect(() => {
        actualizar();
    }, []);

    // Pie chart: Estado
    const estadoLabels = itemsEstado.map(e => e.label);
    const estadoValues = itemsEstado.map(e => e.value);
    const estadoColors = ['#0364FF', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6'];
    const data = {
        labels: estadoLabels,
        datasets: [{
            label: 'Total',
            data: estadoValues,
            backgroundColor: estadoColors.slice(0, estadoLabels.length).map(c => c + '33'),
            borderColor: estadoColors.slice(0, estadoLabels.length),
            borderWidth: 1,
        }],
    };
    const options = {
        plugins: {
            datalabels: {
                display: true,
                color: isDarkMode ? '#e0e0e0' : '#000',
                anchor: 'center',
                font: { weight: 'bold' },
                formatter: (value, context) => {
                    const dataset = context.dataset;
                    const total = dataset.data.reduce((acc, val) => acc + val, 0);
                    return ((value / total) * 100).toFixed(1) + '%';
                },
            },
        }
    };

    const cssCard = {
        background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        minHeight: 85, width: '100%', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', borderRadius: 3,
        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
        border: isDarkMode ? '1px solid #3d4a62' : '1px solid rgba(0, 0, 0, 0.06)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: isDarkMode ? '0 8px 25px rgba(144, 202, 249, 0.15)' : '0 8px 25px rgba(0, 0, 0, 0.12)',
        }
    };

    const CircularProgressWithLabel = (props) => (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" sx={{ color: isDarkMode ? '#3d4a62' : '#dfe2e6' }} size={40} thickness={4} value={100} />
            <CircularProgress variant="determinate" disableShrink sx={{ color: '#1a90ff', animationDuration: '550ms', position: 'absolute', left: 0, [`& .${circularProgressClasses.circle}`]: { strokeLinecap: 'round' } }} size={40} thickness={4} {...props} />
            <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="caption" component="div" sx={{ color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold' }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );

    const cardStyle = {
        background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed',
        borderRadius: 3, p: 2.5, minHeight: 210, transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 12px 24px rgba(3, 100, 255, 0.15)',
            border: '1px solid #0364FF'
        }
    };

    const columns = [
        { name: "id_t", label: "Nro" },
        { name: "fechaCreacion", label: "Creado" },
        { name: "nombre_t", label: "Nombre" },
        { name: "estadoServicio_t", label: "Estado" },
        { name: "subEstadoServicio_t", label: "Sub-Estado" },
        { name: "faseNombre", label: "Fase" },
        { name: "categoria_t", label: "Categoría" },
        { name: "tipoTecnologia_t", label: "Tecnología" },
        { name: "nombrePlan", label: "Plan" },
        { name: "direccion_t", label: "Dirección" },
    ];

    const descargarExcel = () => {
        const dataForExcel = items.map(item => ({
            Nro: item.id_t,
            Creado: item?.fechaCreacion || '-',
            Nombre: item?.nombre_t || '-',
            Estado: item?.estadoServicio_t || '-',
            'Sub-Estado': item?.subEstadoServicio_t || '-',
            Fase: item?.faseNombre || '-',
            Categoría: item?.categoria_t || '-',
            Tecnología: item?.tipoTecnologia_t || '-',
            Plan: item?.nombrePlan || '-',
            Dirección: item?.direccion_t || '-',
            Latitud: item?.latitud_t || '-',
            Longitud: item?.longitud_t || '-',
            Autor: item?.autor?.nombre_p || '-'
        }));
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(dataForExcel);
        XLSX.utils.book_append_sheet(wb, ws, "PreServicios");
        const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array', mimeType: 'application/octet-stream' });
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'dashboardPreServicios.xlsx';
        link.click();
    };

    const onShowModalFilter = () => {
        showModal(ModalFilterDashPreServicios, {
            filtroTotal,
            setFiltroTotal,
            setCountFilter,
            itemsOriginal,
            primeraCarga,
            setItems,
            fechaSelect,
            setFechaSelect,
            setItemsOriginal
        });
    };

    return (
        <Box>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: {xs: 20, sm: 30, md: 40},
                    right: {xs: 20, sm: 30, md: 35},
                    zIndex: 1000,
                    background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                    borderRadius: '50%',
                    boxShadow: '0 8px 25px rgba(3, 100, 255, 0.4)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                        transform: 'scale(1.1)',
                        boxShadow: '0 12px 35px rgba(3, 100, 255, 0.6)',
                        background: 'linear-gradient(135deg, #0247B5 0%, #1a237e 100%)'
                    }
                }}
            >
                <IconButton
                    aria-label="filtros"
                    onClick={() => onShowModalFilter()}
                    sx={{ p: 1, color: '#fff !important' }}
                >
                    <Badge
                        badgeContent={countFilter}
                        sx={{
                            '& .MuiBadge-badge': {
                                background: 'linear-gradient(135deg, #ff4444 0%, #cc0000 100%)',
                                color: 'white',
                                fontWeight: 'bold',
                                boxShadow: '0 2px 8px rgba(255, 68, 68, 0.4)',
                                border: '2px solid white'
                            }
                        }}
                    >
                        <FilterListIcon sx={{ fontSize: 28 }} />
                    </Badge>
                </IconButton>
            </Box>
            <Grid container spacing={2} mb={10}>
                {/* Rango de fecha + Descarga */}
                <Grid item xs={12} sm={12} md={6} lg={3}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Card sx={{
                                background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                p: 2, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', borderRadius: 3,
                                border: isDarkMode ? '1px solid #3d4a62' : '1px solid rgba(0, 0, 0, 0.06)',
                            }}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={10}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography sx={{ color: isDarkMode ? '#b0b0b0' : '#4a5568', fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>
                                                Rango de fecha
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: 16, fontWeight: 700,
                                                background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                                                backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
                                            }}>
                                                {`${FechaFunction.format(fechaSelect.startDate, 'dd-MM-yyyy')} al ${FechaFunction.format(fechaSelect.endDate, 'dd-MM-yyyy')}`}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <MaterialToolTip title="Descargar Excel" arrow>
                                            <IconButton
                                                sx={{ backgroundColor: 'rgba(34, 197, 94, 0.1)', '&:hover': { backgroundColor: 'rgba(34, 197, 94, 0.2)', transform: 'scale(1.1)' }, transition: 'all 0.2s ease' }}
                                                onClick={() => descargarExcel()}
                                            >
                                                <FileDownloadIcon sx={{ color: '#059669', fontSize: 20 }} />
                                            </IconButton>
                                        </MaterialToolTip>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card sx={{
                                ...cssCard,
                                background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)',
                                minHeight: 180, position: 'relative', overflow: 'hidden',
                                '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)', pointerEvents: 'none' }
                            }}>
                                <Typography sx={{ color: '#fff', textAlign: 'center', fontSize: 42, fontWeight: 800, textShadow: '0 2px 4px rgba(0,0,0,0.2)', zIndex: 1, position: 'relative', mb: 1 }}>
                                    {itemsNumber?.total || 0}
                                </Typography>
                                <Typography sx={{ color: '#fff', textAlign: 'center', fontSize: 15, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1, zIndex: 1, position: 'relative', mb: 2 }}>
                                    Total Pre-Servicios
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', zIndex: 1, position: 'relative', mb: 3 }}>
                                    <Chip icon={<FolderOpenIcon sx={{ fontSize: 16, color: '#fff !important' }} />}
                                        label={`${itemsNumber?.activos} Activos`}
                                        sx={{ backgroundColor: 'rgba(34, 197, 94, 0.2)', color: '#fff', fontWeight: 600, fontSize: 12, backdropFilter: 'blur(10px)', border: '1px solid rgba(34, 197, 94, 0.4)' }}
                                    />
                                    <Chip icon={<CheckCircleIcon sx={{ fontSize: 16, color: '#fff !important' }} />}
                                        label={`${itemsNumber?.instalados} Instalados`}
                                        sx={{ backgroundColor: 'rgba(34, 197, 94, 0.2)', color: '#fff', fontWeight: 600, fontSize: 12, backdropFilter: 'blur(10px)', border: '1px solid rgba(34, 197, 94, 0.4)' }}
                                    />
                                    <Chip icon={<BuildIcon sx={{ fontSize: 16, color: '#fff !important' }} />}
                                        label={`${itemsNumber?.cancelados} Cancelados`}
                                        sx={{ backgroundColor: 'rgba(34, 197, 94, 0.2)', color: '#fff', fontWeight: 600, fontSize: 12, backdropFilter: 'blur(10px)', border: '1px solid rgba(34, 197, 94, 0.4)' }}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Pie chart: Por Estado */}
                <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Card sx={{
                        ...cardStyle, height: 310, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
                    }}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Por Estado
                        </Typography>
                        <Chart data={data} type='pie' height={150} width={150} ref={chartRef} options={options} />
                    </Card>
                </Grid>

                {/* Pre-Servicios por estado (barras) */}
                <Grid item xs={12} md={6} lg={5}>
                    <Card sx={{ ...cardStyle, overflowX: 'hidden' }}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 14, mb: 1, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Pre-Servicios por Estado
                        </Typography>
                        <Box className='side' sx={{ maxHeight: 270, overflow: 'auto' }}>
                            {itemsEstado.map((item, idx) => (
                                <Box key={idx} sx={{ p: 1, mt: 0, borderRadius: 2, transition: 'all 0.2s ease', '&:hover': { background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)', cursor: 'pointer' }, overflowX: 'hidden' }}>
                                    <Grid container sx={{ overflowX: 'hidden' }}>
                                        <Grid item xs={3} sm={1.5} md={1.5} lg={1.9} xl={1.5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <CircularProgressWithLabel value={item?.percentage || 0} />
                                        </Grid>
                                        <Grid item xs={9} lg={10} xl={10.5}>
                                            <Typography sx={{ textAlign: 'left', color: isDarkMode ? '#e0e0e0' : '#2d3748', fontWeight: 600, fontSize: 14 }}>
                                                {item?.label || '-'}
                                            </Typography>
                                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Box sx={{ width: '80%', mt: -0.5 }}>
                                                    <LinearProgress variant="determinate" value={item?.percentage || 0} sx={{ height: 9, borderRadius: 1, background: 'rgba(3, 100, 255, 0.1)', '& .MuiLinearProgress-bar.MuiLinearProgress-barColorPrimary': { background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)', borderRadius: 1 } }} />
                                                </Box>
                                                <Box sx={{ width: '20%', mt: -1 }}>
                                                    <Typography sx={{ textAlign: 'center', ml: 1, color: isDarkMode ? '#e0e0e0' : '#2d3748', fontWeight: 700, fontSize: 19, mt: -0.5 }}>
                                                        {item?.value || 0}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))}
                        </Box>
                    </Card>
                </Grid>

                {/* Fase */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Fase
                        </Typography>
                        <BasicTable dataAll={itemsFase} />
                    </Card>
                </Grid>

                {/* Sub-Estado */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Sub-Estado
                        </Typography>
                        <BasicTable dataAll={itemsSubEstado} />
                    </Card>
                </Grid>

                {/* Tecnología */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Tecnología
                        </Typography>
                        <BasicTable dataAll={itemsTecnologia} />
                    </Card>
                </Grid>

                {/* Categoría */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Categoría
                        </Typography>
                        <BasicTable dataAll={itemsCategoria} />
                    </Card>
                </Grid>

                {/* Plan */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Plan
                        </Typography>
                        <BasicTable dataAll={itemsPlan} />
                    </Card>
                </Grid>

                {/* Fechas */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={cardStyle}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Fechas
                        </Typography>
                        <BasicTable dataAll={itemsFechasCreados} />
                    </Card>
                </Grid>

                {/* Pre-Servicios Creados por Usuario */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ ...cardStyle, p: 2.5 }}>
                        <Typography sx={{ fontWeight: 700, color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontSize: 16, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Creados por Usuario
                        </Typography>
                        <Box className='side' sx={{ height: 270, overflow: 'auto' }}>
                            {itemsCreadoUsuario.map((item, idx) => (
                                <Box key={idx} sx={{ p: 1.5, mt: 1, borderRadius: 2, transition: 'all 0.2s ease', '&:hover': { background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)', cursor: 'pointer' } }}>
                                    <Grid container>
                                        <Grid item xs={3} sm={1.5} md={1.5} lg={1.9} xl={1.5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <Avatar src={item?.img} sx={{ border: '2px solid #e3e7ed', transition: 'all 0.2s ease', '&:hover': { border: '2px solid #0364FF' } }} />
                                        </Grid>
                                        <Grid item xs={9} lg={10} xl={10.5}>
                                            <Typography sx={{ textAlign: 'left', color: isDarkMode ? '#e0e0e0' : '#2d3748', fontWeight: 600, fontSize: 14 }}>
                                                {item?.label || '-'}
                                            </Typography>
                                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Box sx={{ width: '80%', mt: -0.5 }}>
                                                    <LinearProgress variant="determinate" value={item?.percentage || 0} sx={{ height: 9, borderRadius: 1, background: 'rgba(3, 100, 255, 0.1)', '& .MuiLinearProgress-bar.MuiLinearProgress-barColorPrimary': { background: 'linear-gradient(135deg, #0364FF 0%, #0247B5 100%)', borderRadius: 1 } }} />
                                                </Box>
                                                <Box sx={{ width: '20%', mt: -1 }}>
                                                    <Typography sx={{ textAlign: 'center', ml: 1, color: isDarkMode ? '#e0e0e0' : '#2d3748', fontWeight: 700, fontSize: 19, mt: -0.5 }}>
                                                        {item?.value || 0}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            ))}
                        </Box>
                    </Card>
                </Grid>

                {/* Tabla detalle */}
                <Grid item xs={12}>
                    <Card sx={{ ...cardStyle, '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 24px rgba(3, 100, 255, 0.1)', border: '1px solid #0364FF' } }}>
                        <TableBase
                            title=''
                            columns={columns}
                            data={items}
                            options={{
                                rowsPerPageOptions: [5],
                                rowsPerPage: 5,
                                print: false, download: false, search: false, filter: false,
                                toolbar: null, customToolbar: null, display: false, viewColumns: false,
                            }}
                        />
                    </Card>
                </Grid>

                {/* Mapa */}
                <Grid item xs={12}>
                    <Card sx={{ ...cardStyle, position: 'relative', '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 24px rgba(3, 100, 255, 0.1)', border: '1px solid #0364FF' } }}>
                        <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#2d3748', textAlign: 'center', fontWeight: 700, fontSize: 18, mb: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Mapa
                        </Typography>
                        <MapBase
                            id="mapaDashPreServ"
                            key='mapaDashPreServ'
                            options={{ maxZoom: 19, minZoom: 7 }}
                            zoom={15}
                            mapContainerStyle={{ marginTop: 0, marginBottom: 0, width: '100%', height: 400 }}
                        >
                            {items?.length > 0 && (
                                items?.map((eitm, idx) => {
                                    if (eitm?.latitud_t && eitm?.longitud_t) {
                                        return (
                                            <MarkerClienteDash
                                                key={idx}
                                                coordenadas={{
                                                    lat: Number(eitm?.latitud_t),
                                                    lng: Number(eitm?.longitud_t)
                                                }}
                                                item={eitm}
                                            />
                                        );
                                    } else {
                                        return <span key={idx}></span>;
                                    }
                                })
                            )}
                        </MapBase>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TabPreServiciosScreen;
